<template>
  <div class="in-box-wrapper">
    <el-card>
      <el-tabs v-model="activeTab">
        <template v-for="(item, index) in tabs">
          <el-tab-pane :label="item.label" :name="item.name" :key="index" v-if="authPromise(item.auth)"></el-tab-pane>
        </template>
      </el-tabs>
      <component :is="activeTab" />
    </el-card>
  </div>
</template>
<script>
import Level from './level'
import Tag from './tag'
export default {
  name: 'in-box',
  components: { Tag, Level },
  data() {
    return {
      tabs: [
        { label: this.$t('customer::customer-manager::level'), name: 'Level', auth: 'customer::customer-manager::level' },
        { label: this.$t('customer::customer-manager::tag'), name: 'Tag', auth: 'customer::customer-manager::tag' }
      ],
      activeTab: 'Level'
    }
  },
  created() {
    if (this.authPromise('customer::customer-manager::tag')) {
      this.activeTab = 'Tag'
    }
    if (this.authPromise('customer::customer-manager::level')) {
      this.activeTab = 'Level'
    }
  }
}
</script>
<style lang="scss" scoped></style>
